import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { DeleteOutline } from '@material-ui/icons';
import { noop } from 'Helpers/PropTypes';

const styles = () => ({
  root: {
    aspectRatio: 1,
  },
});

const DeleteButton = ({
  className,
  classes,
  onClick,
  ...rest
}) => {
  return (
    <IconButton
      className={classNames(classes.root, className)}
      icon={DeleteOutline}
      onClick={onClick}
      color={'red'}
      {...rest}
    />
  );
};

DeleteButton.defaultProps = {
  className: '',
  onClick: noop,
};

DeleteButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default withStyles(styles)(DeleteButton);
